<div class="star-wars-intro black container">
    <p class="intro-text amber-text">
        A few days ago, during...
    </p>
    <h2 class="main-logo"><img alt="Niji logo" src="img/niji-logo.png"></h2>
    <div class="main-content">
        <div class="title-content">
            <p class="content-header">EPISODES IV-VI<br/>A Movie Marathon</p>
            <br>
            <p class="content-body">
                After years of galactic silence, civilization is on the brink of a new Star Wars release. Now, with the
                Force preparing to awaken, the people of Earth seek solace in films of old. With nowhere to turn, they
                gather in great numbers and watch the original trilogy without rest. Three films. 6 hours. 24 minutes.
                Popcorn. Slushies. Total elation.
            </p>
        </div>
    </div>
</div>
